import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';

export const CardLinkSkeleton: FC = () => {
  return (
    <div className="flex flex-1 justify-between rounded-xl border border-solid border-gray-20 px-4 py-3">
      <Skeleton height={24} width={155} />
      <Skeleton height={24} width={24} />
    </div>
  );
};
